import { SessionStorageKeys } from '@/utils/constants';
import { UserManagerSettings } from 'oidc-client-ts';
import config from '@/config.json';

const configDev = {
  VUE_APP_OIDC_AUTHORITY: 'https://idm-dev-taft.apps.silver.devops.gov.bc.ca/auth/realms/taft',
  VUE_APP_URL: 'http://localhost:8080',
  // VUE_APP_TAFT_RETAILER_API: 'https://api-dev-taft.apps.silver.devops.gov.bc.ca/retailer',
  // VUE_APP_TAFT_ADJUDICATION_API: 'https://api-dev-taft.apps.silver.devops.gov.bc.ca/adjudication',
  // VUE_APP_TAFT_TRANSACTION_API: 'https://api-dev-taft.apps.silver.devops.gov.bc.ca/transaction',
  // VUE_APP_TAFT_CITIZEN_API: 'https://api-dev-taft.apps.silver.devops.gov.bc.ca/citizen',
  // VUE_APP_TAFT_REPORTS_API: 'https://api-dev-taft.apps.silver.devops.gov.bc.ca/transaction-reports',
  VUE_APP_TAFT_RETAILER_API: 'http://localhost:3000/retailer',
  VUE_APP_TAFT_ADJUDICATION_API: 'http://localhost:5000/adjudication',
  VUE_APP_TAFT_TRANSACTION_API: 'http://localhost:7000/transaction',
  VUE_APP_TAFT_CITIZEN_API: 'http://localhost:2000/citizen',
  VUE_APP_TAFT_REPORTS_API: 'http://localhost:7000/transaction',
  VUE_APP_ENV_TEST: 'Development Local',
  VUE_APP_MAX_PAGE_SIZE: 100,
  VUE_APP_SPECIAL_AUTH_FORM_URL: 'https://formsflow-dev-taft.apps.silver.devops.gov.bc.ca',
  VUE_APP_TAFT_POS_PDF_URL: 'http://localhost:8080/TAFT_POS_Guide.pdf',
  VUE_APP_TAFT_WEB_PDF_URL: 'http://localhost:8080/TAFT_Web_Guide.pdf',
  VUE_APP_TAFT_FILING_INSTRUCTIONS_PDF_URL: 'http://localhost:8080/eTax_Filing_Instructions.pdf',
  VUE_APP_CALCULATOR_RETAILERS: "['c7becfdd-62a6-42af-a9df-8ae8456cc151', 'testretailerid2']",
  VUE_APP_PAGE_TITLE: "TAFT - Local"
};

const Config = (process.env.NODE_ENV !== 'development_local') ? config : configDev;

const TAFT_CONFIG = {
  OIDC_CONFIG: {
    authority: Config.VUE_APP_OIDC_AUTHORITY ?? '',
    client_id: 'taft-web',
    redirect_uri: `${Config.VUE_APP_URL}/oidc-callback`,
    responseType: 'id_token token',
    scope: 'openid profile',
    silent_redirect_uri: `${Config.VUE_APP_URL}/silent-renew-oidc.html`,
    post_logout_redirect_uri: Config.VUE_APP_URL,
    automaticSilentRenew: true,
    revokeTokensOnSignout: true,
  },
  APP_CONFIG: {
    taftRetailerApiUrl: Config.VUE_APP_TAFT_RETAILER_API,
    taftTransactionApiUrl: Config.VUE_APP_TAFT_TRANSACTION_API,
    taftAdjudicationUrl: Config.VUE_APP_TAFT_ADJUDICATION_API,
    taftCitizenUrl: Config.VUE_APP_TAFT_CITIZEN_API,
    taftReportsUrl: Config.VUE_APP_TAFT_REPORTS_API,
    taftPOSDocsUrl: Config.VUE_APP_TAFT_POS_PDF_URL,
    taftWebDocsUrl: Config.VUE_APP_TAFT_WEB_PDF_URL,
    taftFilingInstructionsUrl: Config.VUE_APP_TAFT_FILING_INSTRUCTIONS_PDF_URL,
  },
  PAGINATION_SIZE: 7,
  MAX_PAGE_SIZE: Config.VUE_APP_MAX_PAGE_SIZE,
  STARTING_YEAR: 2022,
};

export default class ConfigUtils {
  static getOidcSettings(): UserManagerSettings {
    return TAFT_CONFIG.OIDC_CONFIG;
  }

  static getAppConfiguration() {
    return TAFT_CONFIG.APP_CONFIG;
  }

  static getPaginationSize() {
    return parseInt(TAFT_CONFIG.PAGINATION_SIZE.toString(), 10);
  }

  static getMaxPageSize() {
    return TAFT_CONFIG.MAX_PAGE_SIZE;
  }

  static getStartingYear() {
    return TAFT_CONFIG.STARTING_YEAR;
  }

  static getSpecialAuthUrl() {
    return Config.VUE_APP_SPECIAL_AUTH_FORM_URL;
  }

  static getCalculatorRetailers() {
    if (Config.VUE_APP_CALCULATOR_RETAILERS) {
      const retailer_list = Config.VUE_APP_CALCULATOR_RETAILERS.replaceAll("\'", "\"")
      return JSON.parse(retailer_list);
    } else {
      return []
    }
  }

  static getPageTitle(){
    return Config.VUE_APP_PAGE_TITLE;
  }

  static fetchSettingsByKey(sessionKey: string) {
    const taftConfigStr: string | null = sessionStorage.getItem(SessionStorageKeys.TaftConfig);
    const taftConfig = JSON.parse(taftConfigStr || '{}');
    return taftConfig[sessionKey] || {};
  }

  static getDatePickerConfigs() {
    const colorBCBackgroundBlue = '#38598A';
    const colorBCBackgroundBlueLight = '#D7DEE8';
    const masks = {
      input: 'MM/DD/YYYY',
    };
    const attrs = [
      {
        key: 'today',
        highlight: {
          fillMode: 'outline',
          style: {
            width: '32px',
            border: `1px solid ${colorBCBackgroundBlue}`,
            borderColor: colorBCBackgroundBlue,
          },
          contentStyle: {
            color: colorBCBackgroundBlue,
            fontWeight: 600,
          },
        },
        dates: new Date(),
      },
    ];
    const selectStyle = {
      style: {
        backgroundColor: colorBCBackgroundBlue,
        width: '32px',
      },
      contentStyle: {
        color: '#ffffff',
      },
    };
    const selectAttributes = {
      highlight: {
        start: selectStyle,
        base: {
          style: {
            backgroundColor: colorBCBackgroundBlueLight,
          },
        },
        end: selectStyle,
      },
    };
    return {
      masks, attrs, selectStyle, selectAttributes,
    };
  }
}
